import { MACRO_STATO, QUADRANTS } from "@/lib/classification";

// Legenda breve mostrata ovunque compaia la classificazione clienti.
export default function ClassLegend({ variant = "full", className = "" }) {
  return (
    <div className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-[10px] text-muted-foreground ${className}`} data-testid="class-legend">
      {variant !== "stato" && (
        <>
          <span className="font-semibold uppercase tracking-wide">Profilo</span>
          {Object.values(QUADRANTS).map((q) => (
            <span key={q.label} className="flex items-center gap-1">
              <span className={`inline-block h-2.5 w-2.5 rounded-sm ${q.cls}`} />
              {q.label} <span className="opacity-70">({q.desc})</span>
            </span>
          ))}
        </>
      )}
      {variant === "full" && <span className="mx-1 text-border">|</span>}
      {variant !== "matrice" && (
        <>
          <span className="font-semibold uppercase tracking-wide">Stato</span>
          {Object.values(MACRO_STATO).map((m) => (
            <span key={m.label} className="flex items-center gap-1">
              <span className={`inline-block h-2.5 w-2.5 rounded-full border ${m.cls}`} />
              {m.label}
            </span>
          ))}
        </>
      )}
    </div>
  );
}
